module.exports = __webpack_public_path__ + "static/media/delete_acc2.179169ea.jpg";